module.exports = "//public.getcloudapp.com/packs/media/images/icons-conversation-81a08ec3cc7d34bfc6c09ff81999e8d4.svg";